<template>
  <CreditCard
    :image-url="imageUrl"
    :name="name"
    :class="'credit-card--' + name"
  />
</template>
<script>
import CreditCard from './CreditCard'
import image from '../../../../../images/icons/credit_cards/jcb.gif'
export default {
  components: { CreditCard },
  data() {
    return {
      name: 'jcb',
      imageUrl: ''
    }
  },
  mounted() {
    this.imageUrl = image
  }
}
</script>
